import React, { useEffect, useState } from "react";
import OpportunityCard from "@/app/global-components/opportunity-card";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Link } from "react-router-dom";
import EastIcon from "@mui/icons-material/East";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { routes } from "@/consts";
import { LANG } from "@/types";
import useOffer from "@/hooks/useTender";

const OffersPage: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [opportunities, setOpportunities] = useState<any[]>([]);
  const { getOffers } = useOffer();
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const Offers = await getOffers("Opened");
        if (Offers) {
          setOpportunities(Offers.data);
        } else {
          setOpportunities([]);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };

    fetchOffers();
  }, []);
  return (
    <section id="latestOpportunities" className="w-full mb-12 py-12 mt-12 rtl">
      <div className="bg-primary-white">
        <div className="container pt-12 pb-12 mx-auto my-0 px-7">
          <div className="mb-12 text-center">
            <h1 className="text-3xl md:text-3xl lg:text-3xl font-bold  text-gray-800  mb-4">
              {t("general.LatestMedicalTenders")}
            </h1>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {opportunities.slice(0, 8).map((opportunity) => (
              <div key={opportunity.id} className="w-full md:h-[353px]">
                <OpportunityCard opportunity={opportunity} />
              </div>
            ))}
          </div>
          {opportunities.length > 6 && (
            <div className="cursor-pointer hover:text-xl text-center mt-20 text-black bg-white font-bold rounded-md w-fit mx-auto py-2 px-6">
              <Link to={routes.tenders} className="flex items-center gap-2">
                {t("actions.viewMore")}{" "}
                {locale == LANG.EN ? <EastIcon /> : <KeyboardBackspaceIcon />}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default OffersPage;
